import React, { Component } from 'react';

import "./Readmore.scss"

class Readmore extends Component {
    render() {
        return (
            <section className="section section-readmore">
                <a name="more"></a>
                <div className="padding">
                    <div className="container">
                        <div className="poem"></div>
                        <div className="mil"></div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Readmore;



// WEBPACK FOOTER //
// ./src/Components/Readmore/Readmore.jsx